import Agent from "core/services/api";
import { Result } from "core/models";

interface ConfigValueEntity {
    id: number;
    projectId: number;
    key: string;
    value: string;
    insertionDate: string;
    modifiedDate: string;
}

export class ConfigValue<T> {
    id: number;

    projectID: number;

    key: string;

    value: T;

    insertionDate: Date;

    modifiedDate: Date;

    constructor(entity: ConfigValueEntity) {
        this.id = entity.id;
        this.projectID = entity.projectId;
        this.key = entity.key;
        this.value = JSON.parse(entity.value) as T;
        this.insertionDate = new Date(entity.insertionDate);
        this.modifiedDate = new Date(entity.modifiedDate);
    }
}
interface VariantSetting {
    name: string;
    formatkey: string;
    tags?: string[];
}

export interface AwsSetting {
    name: string;
    accesskeyid: string;
    secretaccesskey: string;
    region: string;
    bucketname: string;
    publishsettingkey: string;
}

export interface FtpSetting {
    name: string;
    connectiontype: string;
    hostname: string;
    username: string;
    password: string;
    workingdirectory: string;
    passive: string | boolean;
    explicitpassive: string | boolean;
    publishsettingkey: string;
}

export interface SocialSetting {
    name: string;
    key: string;
    publisherkey: string;
}

type PublisherSetting<T> = {
    name: string;
    key: string;
    publisherkey: string;
    config?: T;
};

type ConfigValues<T> = ConfigValue<T>;
const getConfigByKeyMerged = async <T>(
    accessToken: string,
    key: string,
    projectID: number,
): Promise<Result<ConfigValues<T>, string>> => {
    const request = {
        projectId: projectID,
        key,
    };
    const headers = new Headers();
    headers.append("Authorization", accessToken);
    const result = await Agent.post<ConfigValueEntity[]>(
        "configvalue/getbykeymerged/v1",
        request,
        headers,
        "site",
    );
    if (
        !result.resultObject ||
        result.resultObject.length === 0 ||
        result.messages
    ) {
        return {
            value: undefined,
            error: "unable to load format keys",
        };
    }
    const results = result.resultObject.map((x) => new ConfigValue<T>(x));
    if (results.length === 0) {
        return {
            value: undefined,
            error: "no config values present",
        };
    }
    return {
        value: results[0],
        error: undefined,
    };
};
export { getConfigByKeyMerged, VariantSetting, PublisherSetting };
